module.exports = __webpack_public_path__ + "img/logo-下移.3bb91586.png";